import apiClient from './client';

export const dashboardAPI = {
  getProjectHealth: async () => {
    const response = await apiClient.get('/dashboard/project-health');
    return response.data;
  },

  getFinances: async () => {
    const response = await apiClient.get('/dashboard/finances');
    return response.data;
  },

  getResources: async () => {
    const response = await apiClient.get('/dashboard/resources');
    return response.data;
  },

  getLogistics: async () => {
    const response = await apiClient.get('/dashboard/logistics');
    return response.data;
  },
};
